<ng-container
  *ngrxLet="{
    hemsGateway: hemsStore.hemsGatewaySerialIfNoError$,
    wallBoxDevices: devicesStore.getAllWallboxDevicesWithMatchingBoilerSerial$,
    hemsSubscription: hemsActiveSubscription$
  } as feature"
>
  <ng-container *ngIf="feature.hemsSubscription === hemsType.Lite">
    <div class="settings-container">
      <div
        *ngIf="{
          forecastBased: forecastBased$ | async,
          photovoltaicExcess: photovoltaicExcess$ | async,
          featureTariffBasedFinancialOptimizationState:
            featureTariffBasedFinancialOptimizationState$ | async,
          featureHeatpump: featureHeatpump$ | async,
        } as settings"
      >
        <ng-container
          *ngIf="
            settings.forecastBased ||
              settings.photovoltaicExcess ||
              settings.featureTariffBasedFinancialOptimizationState;
            else noSettings
          "
        >
          <h2 class="title">
            {{ '+HEMS.SETTINGS.OPTIMIZATIONS.FINANCIAL_OPTIMIZATION_TITLE' | translate }}
          </h2>
          <app-hems-financial-optimization
            [isForecastBasedActive]="settings.forecastBased?.properties?.active?.value"
            [hemsGateway]="feature.hemsGateway"
            [featureTariffBasedFinancialOptimizationState]="
              settings.featureTariffBasedFinancialOptimizationState
            "
            [featureForecastBased]="settings.forecastBased"
          ></app-hems-financial-optimization>

          <mat-divider></mat-divider>

          <ng-container>
            <h2 class="title">
              {{ '+HEMS.SETTINGS.OPTIMIZATIONS.OPTIMIZED_DEVICES.TITLE' | translate }}
            </h2>
            <div class="flex flex-col gap-[16px]">
              <app-hems-activate-deactivate-setting-option
                *ngIf="(settings.photovoltaicExcess | ready) || (settings.featureHeatpump | ready)"
                [feature]="settings.photovoltaicExcess || settings.featureHeatpump"
                [title]="'+HEMS.SETTINGS.OPTIMIZATIONS.PHOTOVOLTAIC_EXCESS.TITLE' | translate"
                [hemsGateway]="feature.hemsGateway"
                gtmAction="PV excess handling"
                gtmCategory="Hems"
                gtm="onToggle"
              >
                <p>
                  {{ '+HEMS.SETTINGS.OPTIMIZATIONS.PHOTOVOLTAIC_EXCESS.DESCRIPTION' | translate }}
                </p>
              </app-hems-activate-deactivate-setting-option>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="feature.hemsSubscription === hemsType.Full">
    <div class="settings-container">
      <div
        *ngIf="{
          forecastBased: forecastBased$ | async,
          photovoltaicExcess: photovoltaicExcess$ | async,
          photovoltaicPvExcess: photovoltaicPvExcess$ | async,
          featureTariffBasedFinancialOptimizationState:
            featureTariffBasedFinancialOptimizationState$ | async,
          featureAllowBatteryChargingFromTheGrid: featureAllowBatteryChargingFromTheGrid$ | async,
          featureHeatpump: featureHeatpump$ | async,
          dryContactOptimizationToggles: dryContactOptimizationToggles$ | async
        } as settings"
      >
        <ng-container
          *ngIf="
            settings.forecastBased ||
              settings.photovoltaicExcess ||
              settings.photovoltaicPvExcess ||
              settings.featureTariffBasedFinancialOptimizationState ||
              settings.featureAllowBatteryChargingFromTheGrid;
            else noSettings
          "
        >
          <ng-container>
            <h2 class="title">
              {{ '+HEMS.SETTINGS.OPTIMIZATIONS.FINANCIAL_OPTIMIZATION_TITLE' | translate }}
            </h2>
            <app-hems-financial-optimization
              [isForecastBasedActive]="settings.forecastBased?.properties?.active?.value"
              [hemsGateway]="feature.hemsGateway"
              [featureTariffBasedFinancialOptimizationState]="
                settings.featureTariffBasedFinancialOptimizationState
              "
              [featureAllowBatteryChargingFromTheGrid]="
                settings.featureAllowBatteryChargingFromTheGrid
              "
              [featureForecastBased]="settings.forecastBased"
            ></app-hems-financial-optimization>
          </ng-container>

          <mat-divider></mat-divider>

          <ng-container>
            <h2 class="title">
              {{ '+HEMS.SETTINGS.OPTIMIZATIONS.OPTIMIZED_DEVICES.TITLE' | translate }}
            </h2>
            <div class="flex flex-col gap-[16px]">
              <app-hems-activate-deactivate-setting-option
                *ngIf="settings.forecastBased | ready"
                [feature]="settings.forecastBased"
                [title]="
                  '+HEMS.SETTINGS.OPTIMIZATIONS.FORECAST_BASED_BATTERY_CHARGING.TITLE' | translate
                "
                [hemsGateway]="feature.hemsGateway"
                gtmAction="Forecast based battery charging"
                gtmCategory="Hems"
                gtm="onToggle"
              >
                <p>
                  {{
                    '+HEMS.SETTINGS.OPTIMIZATIONS.FORECAST_BASED_BATTERY_CHARGING.DESCRIPTION'
                      | translate
                  }}
                </p>
              </app-hems-activate-deactivate-setting-option>
              <app-hems-activate-deactivate-setting-option
                *ngIf="(settings.photovoltaicExcess | ready) || (settings.featureHeatpump | ready)"
                [feature]="settings.photovoltaicExcess || settings.featureHeatpump"
                [title]="'+HEMS.SETTINGS.OPTIMIZATIONS.PHOTOVOLTAIC_EXCESS.TITLE' | translate"
                [hemsGateway]="feature.hemsGateway"
                gtmAction="PV excess handling"
                gtmCategory="Hems"
                gtm="onToggle"
              >
                <p>
                  {{ '+HEMS.SETTINGS.OPTIMIZATIONS.PHOTOVOLTAIC_EXCESS.DESCRIPTION' | translate }}
                </p>
              </app-hems-activate-deactivate-setting-option>
              <app-hems-activate-deactivate-setting-option
                *ngIf="settings.photovoltaicPvExcess | ready"
                [feature]="settings.photovoltaicPvExcess"
                [title]="'+HEMS.SETTINGS.OPTIMIZATIONS.PV_EXCESS.TITLE' | translate"
                [hemsGateway]="feature.hemsGateway"
                gtmAction="Weather based PV excess handling"
                gtmCategory="Hems"
                gtm="onToggle"
              >
                <p>{{ '+HEMS.SETTINGS.OPTIMIZATIONS.PV_EXCESS.DESCRIPTION' | translate }}</p>
              </app-hems-activate-deactivate-setting-option>

              <div *ngIf="feature.wallBoxDevices.length > 0" class="charging-mode">
                <p class="text-[18px] font-normal">
                  {{ '+HEMS.SETTINGS.OPTIMIZATIONS.CHARGING_STATION.TITLE' | translate }}
                </p>
                <span class="text-[14px]">
                  {{ '+HEMS.SETTINGS.OPTIMIZATIONS.CHARGING_STATION.DESCRIPTION' | translate }}
                </span>
                <a
                  data-at-wallbox-charging-mode
                  class="charging-mode__action flex flex-row justify-start items-center gap-1 w-fit"
                  gtm="onOpen"
                  gtmAction="Go to Charging mode overlay"
                  gtmCategory="hems"
                  (click)="onOpenChargingMode(feature.wallBoxDevices[0].selectId)"
                >
                  <span class="charging-mode__action__title">{{
                    '+HEMS.SETTINGS.OPTIMIZATIONS.CHARGING_STATION.ACTION_TITLE' | translate
                  }}</span>
                  <mat-icon class="charging-mode__action__icon">arrow_forward</mat-icon>
                </a>
              </div>

              <ng-container *ngFor="let dryContactState of settings.dryContactOptimizationToggles">
                <div class="flex flex-row gap-3">
                  <mat-slide-toggle
                    class="drycontact-toggle"
                    *ngIf="
                      dryContactState.deviceOptimisationToggleFeature$
                        | async as dcOptimizationFeature
                    "
                    [checked]="dcOptimizationFeature?.properties?.active?.value"
                    [disabled]="
                      dryContactState.isDisabled ||
                      (dcOptimizationFeature | executable: featureCommands.setActive)
                    "
                    (change)="updateDryContactOptimisation($event, dcOptimizationFeature)"
                    gtmAction="PV Excess to Dry contacts"
                    gtmCategory="Hems"
                    gtm="onToggle"
                  >
                  </mat-slide-toggle>
                  <div class="flex flex-col">
                    <div class="flex flex-row gap-[8px] justify-start items-center">
                      <p class="text-[18px] font-normal">
                        {{
                        (dryContactState.deviceName$ | async)?.properties?.name?.value ?? 
                        (('+INSTALLATIONS.DRY_CONTACTS.GENERIC_CONSUMER.OTHER_DEVICE' | translate) + '-' + dryContactState.busId)
                        }}
                      </p>
                    </div>
                    <span class="setting-description">
                      <div class="flex flex-row gap-[8px] items-center mt-[8px]">
                        <vi-text size="normal">{{
                          '+HEMS.SETTINGS.OPTIMIZATIONS.PHOTOVOLTAIC_EXCESS.DRY_CONTACT_DESCRIPTION'
                            | translate
                        }}</vi-text>
                      </div>
                    </span>
                  </div>
                </div>
              </ng-container>
            </div>
          </ng-container>
        </ng-container>
      </div>
      <ng-container *ngIf="solarIrradiance$ | async as solarIrradiance">
        <mat-divider></mat-divider>
        <h2 class="title">{{ '+HEMS.SETTINGS.OPTIMIZATIONS.TITLE_EXTRAS' | translate }}</h2>
        <div class="mb-[16px]">
          <app-hems-activate-deactivate-setting-option
            [feature]="solarIrradiance"
            [title]="'+HEMS.SETTINGS.OPTIMIZATIONS.SOLAR_FORECAST.TITLE' | translate"
            [isBetaFeature]="true && !solarIrradiance?.properties?.active?.value"
            [hemsGateway]="feature.hemsGateway"
            gtmAction="Weather based PV excess handling"
            gtmCategory="Hems"
            gtm="onToggle"
          >
            <p>{{ '+HEMS.SETTINGS.OPTIMIZATIONS.SOLAR_FORECAST.DESCRIPTION' | translate }}</p>
          </app-hems-activate-deactivate-setting-option>
        </div>

        <app-banner type="info">
          {{ '+HEMS.SETTINGS.OPTIMIZATIONS.SOLAR_FORECAST.INFO_TEXT' | translate }}
        </app-banner>
      </ng-container>

      <ng-container *ngIf="feature.wallBoxDevices.length > 0">
        <mat-divider></mat-divider>
        <h2 class="title">{{ '+HEMS.SETTINGS.OPTIMIZATIONS.TITLE_POWER_CONTROL' | translate }}</h2>
        <div
          *ngIf="{
            overloadProtection: overloadProtection$ | async,
            gridCurrentLimit: gridCurrentLimit$ | async
          } as settings"
        >
          <ng-container *ngIf="settings.overloadProtection; else noSettings">
            <div class="mb-[16px]">
              <app-hems-activate-deactivate-setting-option
                *ngIf="settings.overloadProtection | ready"
                [feature]="settings.overloadProtection"
                [title]="
                  '+HEMS.SETTINGS.OPTIMIZATIONS.POWER_CONTROL_OVERLOAD_PROTECTION.TITLE' | translate
                "
                [hemsGateway]="feature.hemsGateway"
                gtmAction="Overload Protection"
                gtmCategory="Hems"
                gtm="onToggle"
              >
                <p>
                  {{
                    '+HEMS.SETTINGS.OPTIMIZATIONS.POWER_CONTROL_OVERLOAD_PROTECTION.DESCRIPTION'
                      | translate
                  }}
                </p>
              </app-hems-activate-deactivate-setting-option>
            </div>

            <app-banner type="info">
              {{
                '+HEMS.SETTINGS.OPTIMIZATIONS.POWER_CONTROL_OVERLOAD_PROTECTION.DESCRIPTION_SUGGESTION'
                  | translate
              }}
            </app-banner>
            <app-hems-stepper-setting-option
              *ngIf="settings.gridCurrentLimit | ready"
              [feature]="settings.gridCurrentLimit"
              [title]="
                '+HEMS.SETTINGS.OPTIMIZATIONS.POWER_CONTROL_MAXIMUM_GRID_CURRENT.TITLE' | translate
              "
              [disabled]="!(settings.gridCurrentLimit | executable: featureCommands.setValue)"
              gtmAction="Maximum grid connection current per phase"
              gtmCategory="Hems"
              gtm="onToggle"
            ></app-hems-stepper-setting-option>
          </ng-container>
        </div>
      </ng-container>
    </div>
  </ng-container>
</ng-container>

<ng-template #noSettings>
  <app-banner>{{ '+HEMS.SETTINGS.OPTIMIZATIONS.NO_SETTINGS' | translate }}</app-banner>
</ng-template>
